var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "v-icon__svg",
      attrs: { width: "24px", height: "24px", viewBox: "0 0 24 24" },
    },
    [
      _c("path", {
        attrs: {
          d: "M14,3 C14.5522847,3 15,3.44771525 15,4 L15,5.25 L18,3 L18,9 L15,6.75 L15,8 C15,8.55228475 14.5522847,9 14,9 L8,9 C7.44771525,9 7,8.55228475 7,8 L7,4 C7,3.44771525 7.44771525,3 8,3 L14,3 Z",
        },
      }),
      _c("path", {
        attrs: {
          d: "M11,11 C13.209139,11 15,12.790861 15,15 C15,15.7418188 14.798065,16.4364732 14.4461664,17.031992 L17.4142136,20 L16,21.4142136 L13.031992,18.4461664 C12.4364732,18.798065 11.7418188,19 11,19 C8.790861,19 7,17.209139 7,15 C7,12.790861 8.790861,11 11,11 Z M11,13 C9.8954305,13 9,13.8954305 9,15 C9,16.1045695 9.8954305,17 11,17 C12.1045695,17 13,16.1045695 13,15 C13,13.8954305 12.1045695,13 11,13 Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }